"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function DruvaadmindeletionMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__druvaadmindeletion-multitone-outline__clip0_13467_210)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M2.088 8.314a3.019 3.019 0 011.888-.88L6.2 9.974l.58-.66.8-.92.84-.96c.416.036.812.152 1.172.348.128-.428.492-.76.94-.836a4.19 4.19 0 00-2.372-.724h-.272L6.2 8.15 4.512 6.222H4.24c-1.132 0-2.2.44-3 1.24a4.226 4.226 0 00-1.24 3v2.561h7.736v-1.2H1.2v-1.36c0-.813.316-1.577.888-2.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.776 10.41v4.39H9.388v-4.39h4.388zm0-1.2H9.388c-.66 0-1.2.54-1.2 1.2v4.39c0 .66.54 1.2 1.2 1.2h4.388c.66 0 1.2-.54 1.2-1.2v-4.39c0-.66-.54-1.2-1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M15.4 10.01H7.764a.6.6 0 110-1.2H15.4a.6.6 0 110 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.08 7.462h-.992c-.66 0-1.2.54-1.2 1.2v.976h3.392v-.976c0-.66-.54-1.2-1.2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    fillRule: "evenodd",
    d: "M5.876.012c.216.072.428.148.636.24.264.116.524.244.76.412.132.092.256.2.368.316.192.196.36.416.496.652.104.176.192.365.264.557-1.028-.24-2.064-.24-3.128.364a3.344 3.344 0 01-.032-.528c0-.125.004-.253.016-.377.008-.128.024-.256.044-.384.036-.188.088-.372.156-.548a4.23 4.23 0 01.2-.432c.052-.096.108-.188.16-.284.02 0 .044.004.06.012zm-2.868 3.56c.012.005.128.069.176.097.144.072.288.148.436.216a2.777 2.777 0 001.144.248c.088 0 .176-.008.264-.012a3 3 0 00.424-.056c-.024-.044-.044-.08-.06-.12l-.108-.232a2.978 2.978 0 01-.168-.444 4.091 4.091 0 01-.124-.484c-.028-.144-.04-.288-.056-.428a2.708 2.708 0 01-.004-.312c.004-.105.004-.205.016-.309.008-.056.008-.112.016-.168.016-.124.036-.248.06-.372.016-.084.036-.168.052-.252.004-.02.004-.04.008-.064a4.454 4.454 0 00-.92.68c-.116.116-.232.232-.336.36a3.514 3.514 0 00-.392.629c-.076.148-.144.3-.208.452a5.56 5.56 0 00-.22.572zm1.036.705c0 .012 0 .02.004.032.04.092.072.188.116.276.1.208.228.408.372.588.12.152.256.292.4.42a.974.974 0 00.1.08c.212.152.436.28.672.385.16.072.32.14.484.2.128.052.26.096.396.132.016-.028.032-.052.044-.08.048-.096.096-.192.144-.292.096-.2.18-.409.244-.625.06-.204.104-.416.132-.628.02-.124.036-.32.04-.4.008-.144.004-.288.004-.436v-.064c-1.312.504-2.276.616-3.152.412zm2.868-2.02c.048.072.088.14.132.212.152.248.268.512.348.792a2.95 2.95 0 01.096.904 9.039 9.039 0 01-.168 1.22c.104-.056.204-.104.296-.16.204-.124.392-.264.568-.424.164-.16.316-.336.448-.524a3.9 3.9 0 00.376-.696c.084-.196.16-.396.224-.6.008-.024.012-.048.02-.072-.724-.456-1.496-.692-2.34-.652z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__druvaadmindeletion-multitone-outline__clip0_13467_210"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

DruvaadmindeletionMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
DruvaadmindeletionMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = DruvaadmindeletionMultitoneOutline;
exports["default"] = _default;